import { format } from 'date-fns';

/** "09:00:00" and "09:00" both become "09:00", so saved times match the time slots. */
export const normalizeTime = (time?: string): string => (time ?? '').slice(0, 5);

/** The planned send time in local time, or null when date or time is missing. */
export const getScheduledDate = (date?: string, time?: string): Date | null => {
  if (!date || !time) return null;
  const scheduled = new Date(`${date}T${normalizeTime(time)}`);
  return isNaN(scheduled.getTime()) ? null : scheduled;
};

export const addDays = (date: Date, days: number): Date => {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};

export const formatDayMonth = (date: Date, locale: string): string =>
  date.toLocaleDateString(locale, { day: 'numeric', month: 'long' });

/** Keeps a value that is not among the preset options selectable, e.g. from an existing survey. */
export const withCurrent = <T extends string | number>(
  options: T[],
  current: T | undefined,
): T[] => {
  if (current === undefined || current === '' || options.includes(current)) {
    return options;
  }
  return [...options, current].sort((a, b) => (a < b ? -1 : a > b ? 1 : 0));
};

/**
 * Date (yyyy-MM-dd) and time (HH:mm) in the browser's local time zone, the same
 * zone getScheduledDate and the save use to turn them back into a Date.
 */
export const toFormDateAndTime = (scheduledTime: Date | string) => {
  const scheduledDate = new Date(scheduledTime);
  return {
    date: format(scheduledDate, 'yyyy-MM-dd'),
    time: format(scheduledDate, 'HH:mm'),
  };
};
